module.exports = __webpack_public_path__ + "b7f394b52c3dae9f9bbd34509925904a.woff";